import { render } from "./DateFormatSettings.vue.js?vue&type=template&id=55d56e11!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DateFormatSettings.vue?vue&type=template&id=55d56e11"
import script from "./DateFormatSettings.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DateFormatSettings.vue?vue&type=script&lang=js"
export * from "./DateFormatSettings.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DateFormatSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/FanWeb/scripts/components/config-panel/DateFormatSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55d56e11"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55d56e11', __exports__)) {
    api.reload('55d56e11', __exports__)
  }
  
  module.hot.accept("./DateFormatSettings.vue.js?vue&type=template&id=55d56e11!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DateFormatSettings.vue?vue&type=template&id=55d56e11", () => {
    api.rerender('55d56e11', render)
  })

}


export default __exports__